import { orgToFirestore } from '@parallel-fluidics/shared/models/organizations';
import {
  collection,
  doc,
  getFirestore,
  serverTimestamp,
  setDoc,
} from 'firebase/firestore';

export default async function createOrUpdateOrg({ orgId, validOrgData }) {
  const orgRef = orgId
    ? doc(getFirestore(), 'organizations', orgId)
    : doc(collection(getFirestore(), 'organizations'));

  const orgData = orgToFirestore(validOrgData, serverTimestamp);
  await setDoc(orgRef, orgData);
}
